import {authorize, IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import {
    FalconNavigatorHeader,
    FalconPaymentRequest,
    ICustomerPortalService,
    InstalmentsInfo,
    NewCardForm,
    PolicyPropertyEnum,
    ProductsEnum,
    Types
} from "@falcon/services";
import * as React from 'react';
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {CardForm} from "../../../../../components/payments/CardForm";
import {getAmountToDisplay, getProductByPolicyNumber} from "../../../../../CommonFunctions";
import {lazyInject} from "@athena-portal/core";
import {FailedPaymentMessage} from "../../../../../components/payments/FailedPaymentMessage";

interface IPageParams {
    policyNumber: string;
    [key: string]: string | undefined
}

interface IState {
    newCardForm?: NewCardForm,
    directDebitSupported: boolean
}

@authorize
export class PayOffBalanceNewCardPagePlain extends React.Component<IWithRouterProps<IPageParams>, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IWithRouterProps<IPageParams>) {
        super(props);

        this.state = {
            directDebitSupported: false
        }
    }
    public componentDidMount(): void {
        const request: FalconPaymentRequest = new FalconPaymentRequest();
        const policyNumber = this.props.params.policyNumber;
        request.invoiceType = "PAYOFF";
        request.product = getProductByPolicyNumber(policyNumber);

        this.customerPortalService.getInstalmentsInfoByAgreementNumber(this.props.params.policyNumber).subscribe((output: InstalmentsInfo) => {
            const payOffAmount = output.payOffAmount;
            request.amount = payOffAmount;
            window.sessionStorage.setItem("paymentAmount", getAmountToDisplay(payOffAmount));

            this.customerPortalService.newCardPaymentStart(request, policyNumber).subscribe((newCardForm: NewCardForm) => {
                this.setState({
                    newCardForm
                })
            })
        })
        if (policyNumber) {
            if (getProductByPolicyNumber(policyNumber) === ProductsEnum.HOME) {
                this.setState({
                    directDebitSupported: true
                });
            } else {
                this.customerPortalService.getPolicyPropertyByPropertyKey(policyNumber, PolicyPropertyEnum.DIRECT_DEBIT_SUPPORTED)
                    .subscribe(partyProperty => {
                        this.setState({
                            directDebitSupported: partyProperty?.value === "true"
                        });
                    });
            }
        }
    }
    public render(): React.ReactNode {
        if (this.state.newCardForm) {
            const customLockedTitle = {
                html:
                    (
                        <div className="text-group title plugin no-indent-desktop">
                            <h1 className="m-0">
                                <span className='secure-payment-icon'>Add new card</span>
                            </h1>
                        </div>
                    )
            };
            return (
                <>
                    <FalconHeader/>
                    {this.props.location.state?.paymentFailed && <FailedPaymentMessage directDebitSupported={this.state.directDebitSupported} />}
                    <div className="plugin pay-off-balance-new-card-page">
                        <FalconNavigatorHeader
                            back={`/dashboard/monthlyPaymentHistory/${this.props.params.policyNumber}`}
                            title={customLockedTitle} />
                        <CardForm newCardForm={this.state.newCardForm}
                                  verifyNewCardFailed={false}
                                  policyNumber={this.props.params.policyNumber}
                        />
                    </div>
                    <FalconFooter/>
                </>
            )
        } else {
            return <Overlay show={true}/>
        }
    }
}

export const PayOffBalanceNewCardPage = withRouter<{}, IPageParams>(PayOffBalanceNewCardPagePlain)
